import { Injectable } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { CategoryPage } from '../components/category/category.page';

@Injectable({
	providedIn: 'root'
})
export class CategoryModalService {

	constructor(private modalController: ModalController) { }

	async openCategoryCreationModal(inputData) {
		return new Promise(async (resolve, reject) => {
			const modal = await this.modalController.create({
				component: CategoryPage,
				cssClass: 'create-category-modal',
				backdropDismiss: false,
				componentProps: {
					'categoryData': inputData
				}

			});
			await modal.present();
			const { data } = await modal.onDidDismiss();
			console.log(data);
			resolve(data);
		});

	}
}
